import { Component, OnInit, ChangeDetectorRef, ɵConsole } from '@angular/core';
import { Design } from '../designTest/designTest.model';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, Style } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { QuestionSetService } from '../services/questionset.service';
import { DesignSet, QuestionType } from './edit-questionset.model';
import { promise } from 'protractor';
import {  AfterViewInit, VERSION } from '@angular/core';
import {  Checkqset } from '../services/authentication.service';
import {  MatStepper } from '@angular/material';
import { ViewChild } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './edit-questionset.component.html',
  styleUrls: [ './edit-questionset.component.scss' ]
})

export class EditQuestionSetComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;
  q_set:Checkqset={qsetname:''}
  totalStepsCount: number;
  selectedCategory;
  selectedCategoryindex: string;
  fieldArray = [];
  categoryName: Array<Design> = [];
  typeName: Array<Design> = [];
  complexityName: Array<Design> = [];
  newAttribute: any = {};
  fieldArray1: any = {};
  setname;
  setid;
  questiontypelist = [];

  Unique_or_NonUnique;
  categoryid;
  typeid;
  activate: boolean;
  complexityid;
  typelist = [];
  count;
  duration;
  Question_Category: any;
  result: boolean;
  details: boolean;
  scheduletest: boolean;
  result1;
  length;
  Category;
  Type;
  Question_Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  id;
 // No_of_Candidates;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  overall: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  submitted: boolean = false;
  elsecount: boolean;
  savebtn: boolean;
  categorybtn: boolean;
  typebtn: boolean;
  complexitybtn: boolean;
  countbtn: boolean;
  countbtn1: boolean;
  durationbtn: boolean;
  durationbtn1: boolean;
  private _mobileQueryListener: () => void;
  category: Category = {
    category_name: ''
  };
  type: Type = {
    cate_id:'',
    subcategory_id: '',
    style_id:''
  };
  complexity: Complexity = {
    cate_id:'',
    subcategory_id: '',
    type_id:''
  };
  style: Style = {
    cate_id: '',
    subcategory_id: ''
  }



  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };

  designTest = new FormGroup({
    questionsetname: new FormControl(''),
    category: new FormControl(''),
    type: new FormControl(''),
    complexity: new FormControl(''),
    count: new FormControl(''),
  });
  no_of_candidates_btn: boolean;
  myset: FormGroup;
  unique: any;
  x: string;
  catbtn: boolean;
  type_btn: boolean;
  complex_btn: boolean;
  count_btn: boolean;
  duration_btn: boolean;
  y: any;
  count_btn1: boolean;
  duration_btn1: boolean;
  name: boolean;
  qset: string;
  duplicate: boolean;
  myForm: FormGroup;
  rad_btn: boolean;
  no_of_candidates_button: boolean;
  quessetnamebtn: boolean;

  private ngVersion: string = VERSION.full;

  array: Array<Design> = [];





  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router,  private route: ActivatedRoute,
              private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef,
              media: MediaMatcher, private qs: QuestionSetService) {

    this.simpletest();
    this.data();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.createForm();
  }
  get No_of_Candidates() { return this.myForm.get('No_of_Candidates'); }
  ngOnInit() {
    this.getTempRowData();

    this.route.params.subscribe(params => {
      this.id = params['id'];
  });

    this.edit();

  }

//  get f() { return this.myForm.controls; }
  // get No_of_Candidates() { return this.myForm.get('No_of_Candidates'); }
  createForm() {
    this.myForm = this.fb.group({
      questionsetname: ['', Validators.required ],
      //  No_of_Candidates: ['', Validators.required],
      No_of_Candidates: ['', [Validators.required]],
      Unique_or_NonUnique: ['', Validators.required],
      //  questioncategory: ['', Validators.required ],
      //  questiontype: ['', Validators.required ],
      //  questioncomplexity: ['', Validators.required],
      //  count: ['', [Validators.required, this.countValidator]],
      //  duration: ['', [Validators.required, this.countValidator]],
    });
  }
  countValidator(control: FormControl): ValidationErrors | null {

    let cntval = control.value;
    if (cntval <= 0) {

      return {
          cntError: 'Count should be greater than zero.'
        };
      }
    return null;
  }
  data() {
    this.auth.category(this.category).subscribe(
    (data) => {

     this.Question_Category = data.results;

     this.details = true;
     return this.Question_Category;
    },
    err => {
      console.error(err);
    }
  );

    // this.auth.type(this.type).subscribe(
    // (data) => {
    //
    //  this.Type = data.results;
    //
    //  for( var i=0; i < data.results.length; i++) {
    //  this.fieldArray[i].typelist = this.Type.filter((t: any) => t.Id === +this.selectedCategory);
    //
    //  this.questiontypelist = this.fieldArray[i].typelist;
    //  }
    // //  localStorage.setItem('questiontypelist', JSON.stringify( this.fieldArray[i].typelist));
    // },
    //       err => {
    //         console.error(err);
    //       }
    // );

  //   this.auth.type1(this.type).subscribe(
  //   (data) => {
  //
  //    for( var i=0; i < data.results.length; i++) {
  //     this.Question_Type = data.results[i].Id;
  //
  //     // this.questiontypelist.push(this.Question_Type);
  //    }

  //

  //    this.details = true;
  //    return this.Question_Type;
  //   },
  //   err => {
  //     console.error(err);
  //   }
  // );
    this.auth.complexity(this.complexity).subscribe(
    (data) => {

     this.Complexity = data.results;

     this.details = true;
     return this.Complexity;
    },
    err => {
      console.error(err);
    }
  );
 }


selectChangeHandler(event: any, i: any) {

         this.selectedCategoryindex = i;

         this.selectedCategory = event.target.value;


         this.auth.type(this.type).subscribe(
                  (data) => {

                   this.Type = data.results;


                   this.fieldArray[i].typelist = this.Type.filter((t: any) => t.Id === +this.selectedCategory);

                  },
                        err => {
                          console.error(err);
                        }
                  );
          }

  getTempRowData() {
    this.newAttribute = { question_set_id: '', questionsetname: '', No_of_Candidates: '', Unique_or_NonUnique: '',
                          category: '', type: '', typelist: [], typelistshow: true, complexity: '', count: '' };

  }
  addFieldValue() {
    this.getTempRowData();
    this.fieldArray.push(this.newAttribute);
  }

  deleteFieldValue(index) {
    this.fieldArray.splice(index, 1);
  }
simpletest() {
  this.testschedulerservice.test_scheduler(this.test).subscribe(
  (data) => {

   this.user = sessionStorage.getItem('user');
   this.fname = sessionStorage.getItem('fname');

   this.lname = sessionStorage.getItem('lname');


   if (this.user === '2') {

    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = true;
    this.userTestTaker = true;
    this.details = true;
    this.questionset = true;
    this.scheduletest = true;
    this.overall = true;
    this.evaluate = true;
    this.result = data.results;
    return this.result;
   } else if ( this.user === '1') {
    this.userAdmin = true;
    this.userSuperAdmin = true;
    this.userTestScheduler = true;
    this.userTestTaker = true;
    this.questionset = true;
    this.scheduletest = true;
    this.overall = true;
    this.details = true;
    this.evaluate = true;
    this.result = data.results;
    return this.result;
   } else if ( this.user === '3') {
    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = false;
    this.userTestTaker = true;
    this.questionset = true;
    this.overall = true;
    this.scheduletest = true;
    this.evaluate = true;
    this.details = true;
   } else if ( this.user === '4') {
    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = false;
    this.userTestTaker = false;
    this.questionset = false;
    this.scheduletest = false;
    this.overall = false;
    this.details = false;
    this.evaluate = false;
   }
  },
  err => {
    console.error(err);
  }
);
}

checkqset(){
  this.auth.check_qset(this.q_set).subscribe(
    (data) => {

     this.duplicate=false;
    //  if(data.code==204)
    //  {
    //    this.duplicate=true
    //  }
    //  else{
    //   this.duplicate=false;
    //  }

    if( (this.duplicate)===false&&(this.no_of_candidates_btn)===false&&(this.no_of_candidates_button)===false&&(this.quessetnamebtn)===false&&(this.rad_btn)===false){
      this.goForward();


    }
    },
    err => {
      console.error(err);
    }

  );

}

 create_next(){

    this.x = this.fieldArray[0].No_of_Candidates

    var candi= +this.x;

    this.q_set.qsetname=this.fieldArray[0].questionsetname
    this.checkqset();



    if(this.fieldArray[0].questionsetname=='')
    {
      this.quessetnamebtn=true;

    }
    else{
      this.quessetnamebtn=false;

    }
    if(this.fieldArray[0].No_of_Candidates=='')
    {
      this.no_of_candidates_button=true;
    }
    else{
      this.no_of_candidates_button=false;
    }
    if(candi<=0)
    {
      this.no_of_candidates_btn=true;
    }
    else{
      this.no_of_candidates_btn=false;
    }
    if(this.fieldArray[0].Unique_or_NonUnique=='')
    {
      this.rad_btn=true;
    }
    else{
      this.rad_btn=false;
    }


}

set_next(){
  for (let i = 0; i <= this.fieldArray.length; i++ ) {
    this.x = this.fieldArray[i].count

    var count= +this.x;

    this.y = this.fieldArray[i].duration

    var duration= +this.y;
    if(this.fieldArray[i].category==='')
    {
      this.catbtn=true;
      // alert("Enter Correct Question Set details")
    }
    else{
      this.catbtn=false;

    }
    if( this.fieldArray[i].type==='')
    {
      this.type_btn=true;
    }
    else{
      this.type_btn=false;
    }
    if(this.fieldArray[i].complexity==='')
    {
      this.complex_btn=true;
    }
    else{
      this.complex_btn=false;
    }
    if(this.fieldArray[i].count==='')
    {
      this.count_btn=true;
    }
    else{
      this.count_btn=false;
    }
    if(count<=0)
    {
      this.count_btn1=true;
    }
    else{
      this.count_btn1=false;
    }
    if(this.fieldArray[i].duration==='')
    {
      this.duration_btn=true;
    }
    else{
      this.duration_btn=false;
    }
    if(duration<=0)
    {
      this.duration_btn1=true;
    }
    else{
      this.duration_btn1=false;
    }
    if( (this.duration_btn1 &&  this.duration_btn &&  this.count_btn1 &&  this.count_btn &&  this.complex_btn && this.catbtn && this.type_btn)===false){
      this.goNext();


    }
  }

}

goBack(stepper: MatStepper) {
  stepper.previous();
}

// goForward(stepper: MatStepper){
//   alert("pressed next")
//   stepper.next();
// }

goNext(){

  this.myStepper.next();
  this.update();
}

goForward(){

  this.myStepper.next();
  this.update();
}
update() {
  for (let i = 0; i <= this.fieldArray.length; i++ ) {
    if (this.fieldArray[i].category > 0) {

      if ( this.fieldArray[i].type > 0) {

        if ( this.fieldArray[i].complexity > 0) {

          if ( this.fieldArray[i].count > 0) {

            if ( this.fieldArray[i].duration > 0) {

              this.qs.update(this.fieldArray).subscribe(
                (data) => {

                  if (data.code === 200) {
                  //this.router.navigateByUrl('/question_set');
                  } else {

                }
                },
                err => {
                  console.error(err);
                }
              );

            } else if (this.fieldArray[i].duration === '0') {

              this.durationbtn = true;
            } else if (this.fieldArray[i].duration === '') {
              this.durationbtn1 = true;

            }
          } else if (this.fieldArray[i].count === '0') {

            this.countbtn = true;
            // alert('Count cannot be 0');
           } else if (this.fieldArray[i].count === '') {

             this.countbtn1 = true;
           }
        } else if ( this.fieldArray[i].complexity === '') {

          this.complexitybtn = true;
        }
      } else if ( this.fieldArray[i].type === '') {

        this.typebtn = true;
      }
    } else if (this.fieldArray[i].category === '') {

      this.categorybtn = true;
    }
  }
}


async edit() {
  this.qs.edit(this.id).subscribe(
  async (data) => {
    // this.questiontypelist = JSON.parse(localStorage.getItem('questiontypelist'));



    this.result1 = data.results;


    for (var i = 0 ; i < this.result1.length ; i++) {
        this.setid = this.result1[i].question_set_id;
        this.setname = this.result1[i].question_set_name;
        //this.No_of_Candidates = this.result1[i].No_of_Candidates;
        this.Unique_or_NonUnique = this.result1[i].Unique_or_NonUnique;
        this.categoryid = this.result1[i].categoryid;
        this.typeid = (this.result1[i].typeid);
        this.complexityid = this.result1[i].complexityid;
        this.count = this.result1[i].Count;
        this.duration = this.result1[i].Duration;

        var arr:DesignSet = {
              question_set_id: this.setid,
              questionsetname: this.setname,
              //No_of_Candidates: this.No_of_Candidates,
              Unique_or_NonUnique: this.Unique_or_NonUnique,
              category: this.categoryid,
              type: this.typeid,
              complexity: this.complexityid,
              count: this.count,
              duration: this.duration,
              typelist: [] ,
              typelistshow: true
            };
            // this.fieldArray.push(arr);
        if (this.typeid != null) {
              await this.list();
              arr.typelist = this.questiontypelist;
            }

        this.fieldArray.push(arr);
    }

   });
}

list() {
  return new Promise((resolve) => {
    this.auth.type(this.type).subscribe(
      (data) => {
       this.Type = data.results;
       this.questiontypelist = this.Type.filter((t: any) => t.Id === +this.categoryid);
       resolve(true);
    });
  });
}

generateSet() {

  this.qs.generateSet(this.fieldArray).subscribe(
    (data) => {

      if (data.code === 200) {

        Swal.fire({
          title: 'Success',
          text: data.success,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigateByUrl('/question_set');
          }
        })
        
      }else if (data.code === 400) {
        Swal.fire({
          title: 'Alert',
          text: data.failed,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            // this.router.navigateByUrl('/test_scheduler');
          }
        })

      }
    },
    err => {
      console.error(err);
    }
  );
}

}
